const SET_DANH_SACH_LOG_TRONG_APP_PAGING = (state, danhSachLogTrongAppPaging) => {
  state.danhSachLogTrongAppPaging = danhSachLogTrongAppPaging;
};

export default {
  SET_DANH_SACH_LOG_TRONG_APP_PAGING,
};
